/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GetBorrowerProjectInfosResponse } from './GetBorrowerProjectInfosResponse';
import {
    instanceOfGetBorrowerProjectInfosResponse,
    GetBorrowerProjectInfosResponseFromJSON,
    GetBorrowerProjectInfosResponseFromJSONTyped,
    GetBorrowerProjectInfosResponseToJSON,
} from './GetBorrowerProjectInfosResponse';
import type { GetLegalProtectionRiskResponse } from './GetLegalProtectionRiskResponse';
import {
    instanceOfGetLegalProtectionRiskResponse,
    GetLegalProtectionRiskResponseFromJSON,
    GetLegalProtectionRiskResponseFromJSONTyped,
    GetLegalProtectionRiskResponseToJSON,
} from './GetLegalProtectionRiskResponse';
import type { GetMriRiskResponse } from './GetMriRiskResponse';
import {
    instanceOfGetMriRiskResponse,
    GetMriRiskResponseFromJSON,
    GetMriRiskResponseFromJSONTyped,
    GetMriRiskResponseToJSON,
} from './GetMriRiskResponse';
import type { GetRgiRiskResponse } from './GetRgiRiskResponse';
import {
    instanceOfGetRgiRiskResponse,
    GetRgiRiskResponseFromJSON,
    GetRgiRiskResponseFromJSONTyped,
    GetRgiRiskResponseToJSON,
} from './GetRgiRiskResponse';
import type { GetUnemploymentRiskResponse } from './GetUnemploymentRiskResponse';
import {
    instanceOfGetUnemploymentRiskResponse,
    GetUnemploymentRiskResponseFromJSON,
    GetUnemploymentRiskResponseFromJSONTyped,
    GetUnemploymentRiskResponseToJSON,
} from './GetUnemploymentRiskResponse';
import type { GetUpiRiskResponse } from './GetUpiRiskResponse';
import {
    instanceOfGetUpiRiskResponse,
    GetUpiRiskResponseFromJSON,
    GetUpiRiskResponseFromJSONTyped,
    GetUpiRiskResponseToJSON,
} from './GetUpiRiskResponse';

/**
 * @type RiskData
 * 
 * @export
 */
export type RiskData = { type: 'CBNO' } & GetUpiRiskResponse | { type: 'CHO' } & GetUnemploymentRiskResponse | { type: 'EMP' } & GetBorrowerProjectInfosResponse | { type: 'GLI' } & GetRgiRiskResponse | { type: 'MRI' } & GetMriRiskResponse | { type: 'PJ' } & GetLegalProtectionRiskResponse;

export function RiskDataFromJSON(json: any): RiskData {
    return RiskDataFromJSONTyped(json, false);
}

export function RiskDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskData {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'CBNO':
            return Object.assign({}, GetUpiRiskResponseFromJSONTyped(json, true), { type: 'CBNO' } as const);
        case 'CHO':
            return Object.assign({}, GetUnemploymentRiskResponseFromJSONTyped(json, true), { type: 'CHO' } as const);
        case 'EMP':
            return Object.assign({}, GetBorrowerProjectInfosResponseFromJSONTyped(json, true), { type: 'EMP' } as const);
        case 'GLI':
            return Object.assign({}, GetRgiRiskResponseFromJSONTyped(json, true), { type: 'GLI' } as const);
        case 'MRI':
            return Object.assign({}, GetMriRiskResponseFromJSONTyped(json, true), { type: 'MRI' } as const);
        case 'PJ':
            return Object.assign({}, GetLegalProtectionRiskResponseFromJSONTyped(json, true), { type: 'PJ' } as const);
        default:
            throw new Error(`No variant of RiskData exists with 'type=${json['type']}'`);
    }
}

export function RiskDataToJSON(json: any): any {
    return RiskDataToJSONTyped(json, false);
}

export function RiskDataToJSONTyped(value?: RiskData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'CBNO':
            return Object.assign({}, GetUpiRiskResponseToJSON(value), { type: 'CBNO' } as const);
        case 'CHO':
            return Object.assign({}, GetUnemploymentRiskResponseToJSON(value), { type: 'CHO' } as const);
        case 'EMP':
            return Object.assign({}, GetBorrowerProjectInfosResponseToJSON(value), { type: 'EMP' } as const);
        case 'GLI':
            return Object.assign({}, GetRgiRiskResponseToJSON(value), { type: 'GLI' } as const);
        case 'MRI':
            return Object.assign({}, GetMriRiskResponseToJSON(value), { type: 'MRI' } as const);
        case 'PJ':
            return Object.assign({}, GetLegalProtectionRiskResponseToJSON(value), { type: 'PJ' } as const);
        default:
            throw new Error(`No variant of RiskData exists with 'type=${value['type']}'`);
    }

}

